import { Divider } from 'antd';
import styled from 'styled-components';

export const ToggleText = styled.span`
  display: inline-block;
  margin-left: 10px;
`;

export const MiddleSection = styled.div`
  padding: 0 10px;
  border-right: 1px solid #e9edf0;
  border-left: 1px solid #e9edf0;
`;

export const Header = styled.div`
  font-style: italic;
  color: #979797;
`;

export const LayoutSection = styled.div`
  text-align: center;
  border-top: 1px solid #eceff1;
`;

export const StyledDivider = styled(Divider)`
  height: auto;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  position: relative;
  overflow: hidden;
`;
